// TermsEditor.jsx
import { useEditor, EditorContent } from "@tiptap/react";
import Document from "@tiptap/extension-document";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";
import Bold from "@tiptap/extension-bold";
import Heading from "@tiptap/extension-heading";
import OrderedList from "@tiptap/extension-ordered-list";
import ListItem from "@tiptap/extension-list-item";
import Link from "@tiptap/extension-link";
import Button from "../../components/ui/button/Button";
import "./styles/RTEditorInput.css";
import styles from "./styles/RTEditor.module.css";

const RTEditor = ({ value, onChange }) => {
    const editor = useEditor({
        extensions: [
            Document,
            Paragraph,
            Text,
            Bold,
            Heading.configure({
                levels: [1, 2, 3],
            }),
            OrderedList,
            ListItem,
            Link.configure({
                openOnClick: false,
                autolink: false,
                linkOnPaste: false,
            }),
        ],
        content: value,
        onUpdate({ editor }) {
            onChange(editor.getJSON());
        },
    });

    if (!editor) return null;

    return (
        <>
            <div className={`${styles.tool_bar} flex-container`}>
                <Button
                    body={"bold"}
                    size={"small"}
                    type={"button"}
                    onClickFuction={() =>
                        editor.chain().focus().toggleBold().run()
                    }
                />

                <Button
                    body={"H1"}
                    size={"small"}
                    type={"button"}
                    onClickFuction={() =>
                        editor.chain().focus().toggleHeading({ level: 1 }).run()
                    }
                />
                <Button
                    body={"H2"}
                    size={"small"}
                    type={"button"}
                    onClickFuction={() =>
                        editor.chain().focus().toggleHeading({ level: 2 }).run()
                    }
                />
                <Button
                    body={"H3"}
                    size={"small"}
                    type={"button"}
                    onClickFuction={() =>
                        editor.chain().focus().toggleHeading({ level: 3 }).run()
                    }
                />
                <Button
                    body={"1."}
                    size={"small"}
                    type={"button"}
                    onClickFuction={() =>
                        editor.chain().focus().toggleOrderedList().run()
                    }
                />
                <Button
                    body={"link"}
                    size={"small"}
                    type={"button"}
                    onClickFuction={() => {
                        const url = window.prompt("Enter URL");
                        if (url) {
                            editor.chain().focus().setLink({ href: url }).run();
                        }
                    }}
                />
                <Button
                    body={"unlink"}
                    size={"small"}
                    type={"button"}
                    onClickFuction={() =>
                        editor.chain().focus().unsetLink().run()
                    }
                />
            </div>
            <div>
                <EditorContent editor={editor} />
            </div>
        </>
    );
};

export default RTEditor;
